<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        filterable
        style="margin-right: 10px; margin-bottom: 10px"
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
        @change="screenParkChange"
      >
        <el-option label="全部园区" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.user_id"
        placeholder="请选择认领用户"
        :disabled="screen.park_id == ''"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in userList"
          :key="index"
        ></el-option>
      </el-select>
      <el-input
        class="screenInput"
        v-model="screen.title"
        placeholder="请输入标题"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.garden_num"
        placeholder="请输入唯一编号"
      ></el-input>
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.is_up"
        placeholder="请选择是否上架"
      >
        <el-option label="全部上架状态" value=""></el-option>
        <el-option label="上架" value="1"></el-option>
        <el-option label="下架" value="2"></el-option>
      </el-select>
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.status"
        placeholder="请选择是否认领"
      >
        <el-option label="全部认领状态" value=""></el-option>
        <el-option label="未认领" value="1"></el-option>
        <el-option label="已认领" value="2"></el-option>
      </el-select>
      <el-button
        type="primary"
        @click="(screen.page = 1), fetchData()"
        style="margin-bottom: 5px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px"
        >重置</el-button
      >
    </div>
    <div style="margin-top: 10px">
      <el-button
        type="primary"
        @click="addMenu(0)"
        style="margin-bottom: 5px"
        v-if="roles.includes('/garden/add')"
        >添加</el-button
      >
    </div>

    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="所属园区" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="类型" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.type == 1 ? '共享空间' : "智慧农场会场" }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="标题" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="唯一编号" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.garden_num }}</span>
        </template>
      </el-table-column>
      <el-table-column label="封面图" width="150" align="center">
        <template slot-scope="scope">
          <el-image
            v-for="(img, ind) in scope.row.image.split(',')"
            :key="ind"
            style="width: 120px; height: 40px; margin: 0 5px 5px 0"
            :src="imageOss + img"
            fit="contain"
            :preview-src-list="$pathDispose(scope.row.image.split(','))"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="联系方式" min-width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.contact }}</span>
        </template>
      </el-table-column>
      <el-table-column label="上下架状态" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.is_up == 1 ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.is_up == 1 ? "上架" : "下架" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="认领状态" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status == 1 ? 'danger ' : 'success'"
            disable-transitions
            >{{ scope.row.status == 1 ? "未认领" : "已认领" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="260" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleInfo(scope.row)"
            v-if="roles.includes('/garden/info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/garden/edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/garden/del')"
            >删除</el-button
          >

          <div style="margin-top: 10px" v-if="scope.row.status == 2">
            <el-button
              size="mini"
              type="warning"
              @click="relDelete(scope.row.id)"
              v-if="roles.includes('/garden/del_rel')"
              >删除认领关系</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="cztype == 'see' || userInfo.park_id != 0"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            :disabled="cztype == 'see'"
            class="w4"
            v-model="ruleForm.title"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input
            maxlength="11"
            class="w4"
            :disabled="cztype == 'see'"
            v-model="ruleForm.contact"
            placeholder="请输入联系方式"
          ></el-input>
        </el-form-item>

        <el-form-item label="封面图" prop="image">
          <el-upload
            name="file[]"
            :limit="1"
            :data="{ type: 'image' }"
            class="avatar-uploaders1"
            :action="ossUpload"
            accept=".jpg,.png,.jpeg"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :file-list="fileList"
            :on-remove="picurlHandleRemovePic"
            :on-success="picurlHandleAvatarSuccess"
            :disabled="cztype == 'see'"
            :class="fileList.length > 0 ? 'hide' : ''"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="轮播图" prop="banner">
          <el-upload
            name="file[]"
            :data="{ type: 'image' }"
            class="avatar-uploaders1"
            :action="ossUpload"
            accept=".jpg,.png,.jpeg"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :file-list="thumbFileList"
            :on-remove="handleRemovePic"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :disabled="cztype == 'see'"
          >
            <!-- <img
              v-if="ruleForm.thumb"
              :src="imageUrl + ruleForm.thumb"
              class="avatar-uploaders"
            /> -->
            <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>

        <el-form-item label="详细介绍" prop="details">
          <Editor
            :disabled="cztype == 'see'"
            ref="myQuillEditor"
            style="width: 100%"
            v-model="ruleForm.details"
          />
        </el-form-item>
        <el-form-item label="上下架状态" prop="is_up">
          <el-radio-group v-model="ruleForm.is_up" :disabled="cztype == 'see'">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="2">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { housing_type } from "@/api/common";
import { openPark, delImage, openAgoUser } from "@/api/index";
import {
  gardenAdd,
  gardenEdit,
  gardenList,
  gardenDel,
  gardenInfo,
  delRel,
} from "@/api/smartFarm";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      dialogVisible: false,
      userLoading: true,
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        park_id: "",
        title: "",
        page: 1,
        page_size: 15,
        is_up: "",
        status: "",
        is_page: 1,
        user_id: "",
        garden_num: "",
      },
      typeList: [],
      total: 0,
      ruleForm: {},
      fileList: [],
      thumbFileList: [],
      rules: {
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        title: [{ required: true, message: "请选择标题" }],
        banner: [{ required: true, message: "请选择轮播图" }],
        image: [{ required: true, message: "请选择封面图片" }],
        contact: [{ required: true, message: "请输入联系方式" }],
        details: [
          { required: true, message: "请输入详细介绍", trigger: "blur" },
        ],
        is_up: [{ required: true, message: "请选择是否上架", trigger: "blur" }],
      },
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      registerUser: {
        id: "",
        page: 1,
        page_size: 15,
        total: 0,
      },
      registerUserList: [],
      formTypeList: [],
      percentage: 0,
      percentageShow: true,
      clearThumb: [],
      time_bucket: [
        {
          startTime: "",
          endTime: "",
        },
      ],
      desList: [
        {
          val: "",
        },
      ],
      tabShow: false,
      startTime: "",
      endTime: "",
      userList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
      this.screenParkChange(this.userInfo.park_id);
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    // 删除认领关系
    relDelete(id) {
      var that = this;
      this.$confirm("确认删除认领关系？")
        .then(() => {
          delRel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    screenParkChange(e) {
      this.getUser(e);
    },
    getUser(e) {
      openAgoUser({ park_id: e, is_youke: 2 }).then((res) => {
        this.userList = res.data.lists.data;
      });
    },
    // 比较时间段是否重叠
    Fn() {
      var that = this;
      for (let k in this.time_bucket) {
        if (!that.judege(k)) {
          return false;
        }
      }
      return true;
    },
    judege(idx) {
      for (let k in this.time_bucket) {
        if (idx !== k) {
          if (
            this.time_bucket[k].startTime <= this.time_bucket[idx].startTime &&
            this.time_bucket[k].endTime > this.time_bucket[idx].startTime
          ) {
            return false;
          }
          if (
            this.time_bucket[k].startTime < this.time_bucket[idx].endTime &&
            this.time_bucket[k].endTime >= this.time_bucket[idx].endTime
          ) {
            return false;
          }
        }
      }
      return true;
    },
    handleVideoSuccess(res, file, fileList) {
      this.percentageShow = false;
      if (res.code === 200) {
        this.ruleForm.video = res.data.url;
      } else {
        this.$message.error("上传失败，" + res.msg);
      }
    },
    videoErr() {
      this.$message.error("上传失败");
    },
    picurlHandleRemovePic(file, fileList) {
      this.fileList = [];
      this.ruleForm.image = "";
    },
    handleRemovePic(file, fileList) {
      if (file.response.data.url) {
        this.clearThumb.push(file.response.data.url);
      }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.ruleForm.banner = list.join(",");
    },
    picurlHandleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.fileList.push({ url: this.imageOss + res.data.url });
        this.ruleForm.image = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        console.log(list)
        this.ruleForm.banner = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    reset() {
      this.screen = {
        park_id: "",
        title: "",
        page: 1,
        page_size: 15,
        is_up: "",
        status: "",
        is_page: 1,
        user_id: "",
        garden_num: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              gardenEdit(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.fileList = [];
      this.thumbFileList = [];
      this.clearVideos = [];
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 查看
    handleInfo(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      this.fileList = [];
      this.thumbFileList = [];
      this.clearVideos = [];
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      gardenInfo({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          id: res.data.id,
          park_id: Number(res.data.park_id),
          title: res.data.title,
          contact: res.data.contact,
          details: res.data.details,
          image: res.data.image,
          banner: res.data.banner.join(","),
          is_up: res.data.is_up,
        };

        if (res.data.image) {
          var list = res.data.image.split(",");
          this.fileList = list.map((item) => {
            return {
              name: +new Date(),
              url: this.imageOss + item,
              response: {
                data: {
                  url: item,
                },
              },
            };
          });
        }
        if (res.data.banner) {
          this.thumbFileList = res.data.banner.map((item) => {
            return {
              name: +new Date(),
              url: this.imageOss + item,
              response: {
                data: {
                  url: item,
                },
              },
            };
          });
        }
      });
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          gardenDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      // return;
      var that = this;
      // return;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              console.log(that.ruleForm)
              gardenAdd(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        park_id: "",
        title: "",
        contact: "",
        image: "",
        banner: "",
        details: "",
        is_up: 1,
      };
      this.fileList = [];
      this.thumbFileList = [];
      this.clearThumb = [];
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      gardenList(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin-right: 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}

.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}

.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}
.tabBox {
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>
